import { SxProps, Theme } from '@mui/material'

/**
 * Compact pill toggle group used for chart/card controls (range selectors, mode switches)
 * inside the market-analytics detail cards. Pairs with `size="small"` on the
 * `ToggleButtonGroup`. Matches the GR convention of highlighting the selected option with
 * `palette.primary` (same approach as `GRSubTabNavigation` and `NavigationModeToggler`).
 */
export const compactToggleGroupSx: SxProps<Theme> = {
  '& .MuiToggleButton-root': {
    // Title Case labels rather than the MUI default all-caps.
    textTransform: 'capitalize',
    py: 0.25,
    px: 1.5,
    minHeight: 28,
    lineHeight: 1.4,
    fontSize: '0.75rem',
    // Meet WCAG 2.5.5 on touch without inflating the control on fine pointers.
    '@media (pointer: coarse)': {
      minHeight: 44,
    },
    '&.Mui-selected': {
      color: (theme) => theme.palette.primary.contrastText,
      backgroundColor: (theme) => theme.palette.primary.main,
      '&:hover': {
        backgroundColor: (theme) => theme.palette.primary.dark,
      },
    },
  },
}
